<template>
    <div class="loginPage">
        <div class="loginPanel">
            <div class="logo"></div>
            <form class="form">
                <div class="title">江苏省工程咨询协会</div>
                <div class="title">单位管理服务系统</div>
                <div class="split"></div>
                <div class="welcome">欢迎登录</div>
                <input type="text" ref="userName" v-model="userName" autocomplete="off" placeholder="请输入用户名" @keypress.enter.prevent="onUserNameEnter" />
                <div />
                <input
                    type="password"
                    ref="userPassword"
                    v-model="userPassword"
                    placeholder="请输入密码"
                    autocomplete="off"
                    @keypress.enter.prevent="onUserPasswordEnter"
                />
                <div />
                <a @click="register" style="color: #fff;margin-top: 5px">注册账号</a>
                <button :disabled="loading" @click.stop="doLogin">{{ loading ? "登录中..." : "登录" }}</button>
            </form>
        </div>
        <ChangeInfo :showEdit.sync="showEdit" :needChangePwd.sync="needChangePwd" :inputUserName.sync="userName" />
    </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from "vuex";
import ChangeInfo from "../main/userInfo/ChangeInfo.vue";
const user = createNamespacedHelpers("user");
export default {
    components: { ChangeInfo },
    data() {
        return {
            // 表单绑定的数据
            userName: "",
            userPassword: "",
            // 登录
            userToken: null,
            loginLoading: false,
            // 用户信息
            userInfo: null,
            userInfoLoading: false,
            // 用户菜单
            userMenusLoading: false,
            showEdit: false,
            needChangePwd: false
        };
    },
    computed: {
        loading() {
            return this.loginLoading || this.userInfoLoading || this.userMenusLoading;
        }
    },
    methods: {
        ...user.mapActions(["setToken", "setUserInfo", "setUserMenus", "logout"]),
        ...mapActions(["setStaticVarData", "setMessageData", "setDictData", "setSelectData", "setObjVarData"]),
        register() {
            this.$FG_http.post("./api/jsaec/register/init", { scope: 0 }, { showError: true, showSuccess: false }).then(({ success, data, errMsg }) => {
                if (success) {
                    // 设置初始化信息
                    this.setStaticVarData(data.data.staticVar);
                    this.setMessageData(data.data.staticMsg);
                    this.setDictData(data.data.dictItem);
                    this.setSelectData(data.data.selectInfo);
                    this.setObjVarData(data.data.objVar);
                }
                this.$router.push("/register");
            });
            /*this.$FG_http
                .post("./api/admin/user/login", { username: "admin", password: "register" }, { showSuccess: false })
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        // 登录成功
                        this.setToken(data.data);
                        this.$FG_http.post("./api/admin/user/getUserByToken", {}, { showSuccess: false }).then(({ success, data, errMsg }) => {
                            this.setUserInfo(data.data);
                        });
                        this.$FG_http
                            .post("./api/common/framecore/init", { scope: 0 }, { showError: true, showSuccess: false })
                            .then(({ success, data, errMsg }) => {
                                if (success) {
                                    // 设置初始化信息
                                    this.setStaticVarData(data.data.staticVar);
                                    this.setMessageData(data.data.staticMsg);
                                    this.setDictData(data.data.dictItem);
                                    this.setSelectData(data.data.selectInfo);
                                    this.setObjVarData(data.data.objVar);
                                }
                                this.$router.push("/register");
                            });
                    }
                });*/
        },
        onUserNameEnter(e) {
            if (this.userName) {
                this.$refs.userPassword.focus();
            }
        },
        onUserPasswordEnter() {
            if (this.userName === "") {
                this.$refs.userName.focus();
            } else {
                this.doLogin();
            }
        },
        doLogin() {
            if (this.loading) {
                return;
            }
            if (this.userName === "") {
                this.$refs.userName.focus();
                return;
            }
            // 执行登录操作
            this.loginLoading = true;
            this.$FG_http
                .post("./api/admin/user/login", { username: this.userName, password: this.userPassword, server: "company" }, { showSuccess: false })
                .then(({ success, data, errMsg }) => {
                    this.loginLoading = false;
                    if (success) {
                        this.$cookies.set("userName", this.userName);
                        // 登录成功
                        this.setToken(data.data);
                        this.needChangePwd = data.message === "您的密码安全等级过低，请先修改密码!";
                        if (this.needChangePwd) {
                            this.showEdit = true;
                            return;
                        }
                        // 获取当前用户信息
                        this.userInfoLoading = true;
                        this.$FG_http.post("./api/admin/user/getUserByToken", {}, { showSuccess: false }).then(({ success, data, errMsg }) => {
                            this.userInfoLoading = false;
                            if (success) {
                                const userInfo = data.data;
                                this.$FG_http
                                    .post("./api/admin/user/getUserDW", { id: userInfo.id }, { showSuccess: false })
                                    .then(({ success, data, errMsg }) => {
                                        if (success) {
                                            if (data.data) {
                                                // 保存用户信息
                                                userInfo.companyInfo = data.data;
                                            } else {
                                                userInfo.companyInfo = {};
                                            }
                                            this.getUserMenus(userInfo);
                                        }
                                    });
                            } else {
                                this.$refs.userName.focus();
                            }
                        });
                    } else {
                        this.$refs.userPassword.focus();
                    }
                });
        },
        getUserMenus(userInfo) {
            // 获取用户菜单
            this.userMenusLoading = true;
            this.$FG_http.post("./api/admin/user/getMenuList", { menu_type: "dw" }, { showSuccess: false }).then(({ success, data, errMsg }) => {
                this.userMenusLoading = false;
                if (success) {
                    // 保存用户信息
                    this.setUserInfo(userInfo);
                    this.setUserMenus(this.filterMenu(userInfo, data.data));
                    // 转到主页面
                    this.$router.push({ name: "main" });
                } else {
                    this.$refs.userName.focus();
                }
            });
        },
        filterMenu(userInfo, menus) {
            let params = ["常务理事单位", "会长单位", "副会长单位", "监事单位", "理事单位"];
            let dwlb = userInfo.companyInfo.dwlb;
            return menus.filter((item) => {
                if (item.menu_name === "单位调查管理") {
                    if (params.indexOf(dwlb) === -1) {
                        return false;
                    } else {
                        item.children = [item.children[1]];
                    }
                }
                return true;
            });
        }
    },
    mounted() {
        // 注销之前的登录
        this.$FG_http
            .post("./api/admin/user/logout", {}, { showError: false, showSuccess: false })
            .then(() => {
                // 清空用户信息
                this.setToken(null);
                this.setUserInfo(null);
                this.setUserMenus(null);
            })
            .then(() => {
                this.userName = this.$cookies.get("userName");
                if (this.userName) {
                    this.$refs.userPassword.focus();
                } else {
                    this.$refs.userName.focus();
                }
            });
    }
};
</script>
<style lang="scss" scoped>
.loginPage {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-image: url("../../assets/images/bg.png");
    background-repeat: no-repeat;
    background-position: 0px 0px;
    background-size: cover;
    .loginPanel {
        position: absolute;
        top: 50vh;
        left: 50vw;
        margin-top: -140px;
        margin-left: -270px;
        background: transparent;
        display: flex;
        flex-direction: row;

        .logo {
            width: 200px;
            background-image: url("../../assets/images/logo_collapsed.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: auto 120px;
            border-width: 0 1px 0 0;
            border-style: solid;
            border-color: rgba(244, 246, 247, 0.5);
        }

        .form {
            width: 320px;
            margin-left: 40px;
            background-color: transparent;
            display: flex;
            flex-direction: column;

            .title {
                font-size: 30px;
                color: #fff;
                line-height: 50px;
                width: 320px;
            }
            .split {
                height: 4px;
                width: 36px;
                background-color: #fff;
            }
            .welcome {
                font-size: 16px;
                color: #fff;
                line-height: 30px;
            }

            input {
                height: 36px;
                margin-top: 20px;
                background-color: #fff;
                border: none;
                outline: none;
                font-size: 16px;
                color: #444;

                &::placeholder {
                    color: #bab8c9;
                }
            }

            input[type="text"] {
                background-image: url("../../assets/images/user.png");
                background-repeat: no-repeat;
                background-position: left 8px top 8px;
                background-size: auto 50%;
                padding-left: 45px;
            }
            input[type="password"] {
                background-image: url("../../assets/images/password.png");
                background-repeat: no-repeat;
                background-position: left 8px top 8px;
                background-size: auto 50%;
                padding-left: 45px;
            }

            button {
                margin-top: 25px;
                margin-bottom: 20px;
                border: none;
                font-size: 18px;
                line-height: 36px;
                outline: none;
                color: #fff;
                background-color: #05b7d2;

                &:disabled {
                    background-color: #878c8f;
                    font-size: 16px;
                }

                &:hover:not(:disabled) {
                    background-color: #68e5f8;
                }

                &:active:not(:disabled) {
                    background-color: #16d8f5;
                }
            }
        }
    }
}
</style>
